import { DataService } from 'src/app/data.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-request-award',
  templateUrl: './request-award.component.html',
  styleUrls: ['./request-award.component.scss']
})
export class RequestAwardComponent implements OnDestroy {

  destroy$: Subject<boolean> = new Subject<boolean>();

  form = new FormGroup({
    website: new FormControl('business-salonexpert'),
    name: new FormControl(null, [Validators.required]),
    link: new FormControl(null, [Validators.required]),
  });

  awardRequestTnx = false;
  showForm = false;
  submited = false;

  constructor(
    private readonly data: DataService
  ) { }

  ngOnDestroy() {
    this.awardRequestTnx = false;
    this.showForm = false;
    this.submited = false;
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      this.submited = true;
      this.data.invoke(`/salonexpert-business/client/award-request`, 'post', null, this.form.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        res => {
          this.submited = false;
          this.showForm = false;
          this.awardRequestTnx = true;
        },
        err => {
          this.submited = false;
        }
      )
    }
  }

}
